export default  {
  title: {
    en: 'Too many perfumes? Simply change your plan',
  },
  text: {
    en: `
      Your current plan is <span class="brandColor">{productsPerPeriod} products in month</span>.
      You can downgrade before the next charge on {nextBillingDate}
    `,
  },
  buttonTitle: {
    primary: {
      en: 'Confirm',
    },
    ordinary: {
      en: 'Continue cancellation',
    },
  },
}
